import { and, eq, or, gte, isNull } from "drizzle-orm";
import { g as getDB, l as link } from "../../../../chunks/index3.js";
import { redirect } from "@sveltejs/kit";
import { isbot } from "isbot";
import "clsx";
import "@sveltejs/kit/internal";
import "../../../../chunks/exports.js";
import "../../../../chunks/utils.js";
import "../../../../chunks/client2.js";
import "ts-deepmerge";
import "../../../../chunks/formData.js";
import { s as superValidate, f as fail, a as setError } from "../../../../chunks/superValidate.js";
import "memoize-weak";
import { l as valibot, P as PassphraseSchema } from "../../../../chunks/valibot.js";
import "zod-to-json-schema";
import "../../../../chunks/runtime.js";
import { s as shrtn_passphrase_invalid } from "../../../../chunks/shrtn_passphrase_invalid.js";
const isExpired = (date, refDate) => {
  return date.getTime() < refDate.getTime();
};
const load = async ({ params, request, url }) => {
  const db = getDB();
  const { shorten } = params;
  const data = await db.select({
    link: link.url,
    passphrase: link.passphrase,
    calls: link.calls,
    callLimit: link.callLimit,
    expiresAt: link.expiresAt
  }).from(link).where(
    and(
      eq(link.id, shorten),
      or(gte(link.expiresAt, /* @__PURE__ */ new Date()), isNull(link.expiresAt))
    )
  ).get();
  if (data == null || data.expiresAt && isExpired(data.expiresAt, /* @__PURE__ */ new Date())) {
    return {
      code: 404
    };
  }
  if (data.callLimit != null && data.callLimit < (data.calls ?? 0)) {
    return {
      code: 404
    };
  }
  if (data.passphrase != null) {
    const form = await superValidate(valibot(PassphraseSchema));
    return {
      code: 401,
      form
    };
  }
  if (data.callLimit != null && !isbot(request.headers.get("User-Agent"))) {
    await db.update(link).set({
      calls: data.calls ?? 0 + 1
    });
  }
  return redirect(302, data.link);
};
const actions = {
  passphrase: async ({ request, params }) => {
    const { shorten } = params;
    const db = getDB();
    const form = await superValidate(request, valibot(PassphraseSchema));
    if (!form.valid) {
      return fail(400, { form });
    }
    const result = await db.select({
      url: link.url,
      calls: link.calls,
      callLimit: link.callLimit
    }).from(link).where(and(eq(link.id, shorten), eq(link.passphrase, form.data.passphrase))).get();
    if (!result) {
      return setError(form, "passphrase", shrtn_passphrase_invalid());
    }
    if (result.callLimit != null) {
      await db.update(link).set({
        calls: result.calls ?? 0 + 1
      });
    }
    return redirect(302, result.url);
  }
};
export {
  actions,
  load
};
